import { render, staticRenderFns } from "./SwitchLayout.vue?vue&type=template&id=598c6cb2&"
import script from "./SwitchLayout.vue?vue&type=script&lang=js&"
export * from "./SwitchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLayout.vue?vue&type=style&index=0&id=598c6cb2&prod&lang=scss&soped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports